import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

type Props = {
  headline?: string | null;
  subheader?: string | null;
};

const getSpecializationDescription = (headline?: string | null, subheader?: string | null) => {
  let description = '';

  if (headline) {
    description += headline;
  }

  if (subheader) {
    description = description.trim().length > 0 ? description.trim() + '. ' + subheader : subheader;
  }

  return description;
};

const HeroSpecializationDescription = ({ headline, subheader }: Props) => {
  if (headline || subheader) {
    return (
      <Typography2 component="p" variant="bodyPrimary">
        {getSpecializationDescription(headline, subheader)}
      </Typography2>
    );
  } else {
    return null;
  }
};

export default HeroSpecializationDescription;
